import { GetAccountTypes, GetCustomAccounts } from "../services/accountService";
const requestCustomAccountsType = "REQUEST_CUSTOM_ACCOUNTS";
const receiveCustomAccountsType = "RECEIVE_CUSTOM_ACCOUNTS";
const requestAccountTypesType = "REQUEST_ACCOUNT_TYPES";
const receiveAccountTypesType = "RECEIVE_ACCOUNT_TYPES";
const CUSTOM_ACCOUNT_MODAL_LOAD_TYPE = "CUSTOM_ACCOUNT_MODAL_LOAD";
const initialState = {
  customAccounts: [],
  accountTypes: [],
  loading: false,
  loadingAccountTypes: false
};

export const actionCreators = {
  requestCustomAccounts: () => async (dispatch, getState) => {
    dispatch({ type: requestCustomAccountsType });

    const customAccounts = await GetCustomAccounts();

    dispatch({ type: receiveCustomAccountsType, customAccounts });
  },
  requestAccountTypes: () => async (dispatch, getState) => {
    dispatch({ type: requestAccountTypesType });

    const accountTypes = await GetAccountTypes();

    dispatch({ type: receiveAccountTypesType, accountTypes });
  },
  loadCustomAccountModal: data => async dispatch => {
    dispatch({ type: CUSTOM_ACCOUNT_MODAL_LOAD_TYPE, data });
  }
};

export const reducer = (state, action) => {
  state = state || initialState;

  if (action.type === requestCustomAccountsType) {
    return {
      ...state,
      loading: true
    };
  }

  if (action.type === receiveCustomAccountsType) {
    const { customAccounts } = action;
    return {
      ...state,
      customAccounts,
      loading: false
    };
  }

  if (action.type === requestAccountTypesType) {
    return {
      ...state,
      loadingAccountTypes: true
    };
  }

  if (action.type === receiveAccountTypesType) {
    const { accountTypes } = action;
    return {
      ...state,
      accountTypes,
      loadingAccountTypes: false
    };
  }

  if (action.type === CUSTOM_ACCOUNT_MODAL_LOAD_TYPE) {
    const { data } = action;
    return {
      ...state,
      data
    };
  }

  return state;
};
